import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { AdminHeader } from './AdminHeader';
import { AdminSidebar } from './AdminSidebar';
import { SEOHead } from '../common/SEOHead';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  padding: 2rem;
  margin-left: 250px;
  
  @media (max-width: 768px) {
    margin-left: 0;
    padding: 1rem;
  }
`;

export const AdminLayout: React.FC = () => {
  return (
    <LayoutContainer>
       <SEOHead title="Gala Raf - Admin" />
      <AdminSidebar />
      <ContentWrapper>
        <AdminHeader />
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentWrapper>
    </LayoutContainer>
  );
};